import Guid from "../Guid";

import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import React, {useContext, useRef, useState} from "react";
import ProgressLoading from "../loading/ProgressLoading";
import VideoValidationGuideImage from "../../images/guide/VideoValidation_guide.png";
import Api from "../../tools/service";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import VideoCamera1 from "../VideoCamera1";
import Final from "./Final";


const VideoValidation = () => {
    const serviceContext = useContext(AuthenticationServiceContext);
    const videoValidationWebcam = useRef(null);
    const [showGuide, setShowGuide] = useState(true);
    const [isLoading, setLoading] = useState(false)
    const [step, setStep] = useState(1);
    const [video, setVideo] = useState('')
    const [timerCount, setTimerCount] = useState(7);
    const [isReported, setReported] = useState(false);
    const [reportMessage, setReportMessage] = useState('')
    const VideoValidationGuidSlides = [
        {
            image: VideoValidationGuideImage,
            title: "ونیفای",
            subTitle: "احراز هویت ویدیویی",
            texts: `در شرایط نوری مناسب  بدون عینک و ماسک از چهره خود ویدیو بگیرید.`
        }
    ]
    if (isLoading) {
        return <ProgressLoading showProgress={true} type="VideoValidation" text={'در حال احراز هویت ویدیو'}
                                duration={30} theme="green"/>
    }

    const handleVideoValidation = () => {
        setLoading(true);
        /*const imageIndex = nidImage.indexOf(";base64,") + 8;*/
        const videoIndex = video.indexOf(";base64,") + 8;
        handleGenerateUuid('VideoValidation', serviceContext.token).then((generatedUuid) => {
            Api.post(REQUEST_URLS.AUTHENTICATION.VIDEO_VALIDATION, {
                pid: serviceContext.pid,
                uuid: generatedUuid,
                Video: video.substr(videoIndex),
            }, {
                headers: {
                    "Authorization": `Bearer ${serviceContext.token}`
                }
            }).then((response) => {

                const {data, hasError, status, message} = response;

                if (!hasError) {
                    if (data.warning) {
                        setReported(true);
                        setReportMessage(data.warning);
                        setLoading(false)
                    } else {
                        serviceContext.handleGetProcess(serviceContext.pid)
                    }


                } else {
                    if (status === 521) {
                        setTimerCount(13)
                    }
                    setLoading(false)
                    serviceContext.handleError({
                        message, status, data, callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                pid: serviceContext.pid,
                                onConfirm: () => {
                                    if (data?.can_reset) {
                                        serviceContext.handleReset(serviceContext.pid);
                                        Reoverlay.hideModal();
                                    }
                                },
                                showConfirmButton: data?.can_reset,
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                confirmButtonText: 'ویرایش اطلاعات',
                                cancelButtonTheme: 'red',
                                onCancel: () => {
                                    setShowGuide(false)
                                    setStep(1);
                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })

                }
            }).catch((error) => {
                console.log(error)
                setLoading(false)
            }).finally(() => {

            });
        }).catch(() => {

        })
    }
    const handlePrev = () => {
        setStep(step - 1)
    }
    const handleCapture = (video) => {
        setVideo(video);
        setStep(step + 1)

    }
    if(isReported){
        return  <Final isDisableTitle={false} message={reportMessage}/>
    }
    return <div className="w-11/12 mx-auto md:w-6/12 mt-5 lg:w-4/12">
        {showGuide && step === 1 &&
            <Guid imageClass={'w-8/12 md:w-8/12 lg:w-3/12 xl:w-2/12 '} closeGuid={() => setShowGuide(false)}
                  slides={VideoValidationGuidSlides}/>}
        {!showGuide && step === 1 &&
            <VideoCamera1 title={'احراز هویت ویدیو'} min={timerCount} max={timerCount} handleShowGuid={() => {
                setShowGuide(true)
            }} webcamRef={videoValidationWebcam}  faceMode="user"
                          onCapture={handleCapture}/>
        }
        {!showGuide && step === 2 && <>
            <div className="w-full flex justify-center flex flex-col items-center ">
                <div className="w-full lg:w-56 overflow-hidden">
                    <video className={"cursor-pointer"} controls onClick={e => e.target.play()}
                           src={video}/>
                </div>
            </div>
            <BottomButtonWrapper grid={2}>
                <Button onClick={handleVideoValidation} className={"w-full"} rounded="rounded-lg"
                        theme="green">تایید</Button>
                <Button onClick={() => {
                    handlePrev()
                }} className={"w-full"} rounded="rounded-lg" theme="light">تلاش مجدد</Button>
            </BottomButtonWrapper>
        </>}

    </div>
}
export default VideoValidation;